
import { createClient } from '@supabase/supabase-js';

/**
 * 🛠️ SIGMA CONNECTION ENGINE
 * Optimized to handle browser-side blocking (Ad-blockers).
 */

const rawUrl = 'https://yalygtxbbbarxycnagms.supabase.co';
const rawKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlhbHlndHhiYmJhcnh5Y25hZ21zIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg1ODIxMTEsImV4cCI6MjA4NDE1ODExMX0.gN97WKRPHYX5Cch_I-LPAAPnHmnl7n9oUFzwDmyUcw4';

const supabaseUrl = rawUrl.trim().replace(/\/+$/, '');
const supabaseAnonKey = rawKey.trim();

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});

/**
 * Diagnoses exactly why the app is stuck in "Rescue Mode".
 */
export const diagnoseConnection = async () => {
  const results = {
    network: 'unknown',
    auth: 'unknown',
    database: 'unknown',
    storage: 'unknown',
    details: ''
  };

  try {
    // 1. Connectivity Check
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);
    
    try {
      await fetch(`${supabaseUrl}/rest/v1/`, { 
        method: 'HEAD', 
        headers: { 'apikey': supabaseAnonKey },
        signal: controller.signal 
      });
      results.network = '✅ Connected';
    } catch (e: any) {
      if (e.name === 'AbortError') {
        results.network = '❌ Timeout';
        results.details = 'The connection timed out. Your internet might be slow or Supabase is down.';
      } else {
        results.network = '❌ Blocked';
        results.details = 'The request was blocked by your browser. PLEASE DISABLE AD-BLOCKERS (uBlock, AdBlock, etc.) for this domain.';
      }
      return results;
    } finally {
      clearTimeout(timeoutId);
    }

    // 2. Auth Check
    const { data: { session }, error: authError } = await supabase.auth.getSession();
    results.auth = authError ? `❌ ${authError.message}` : session ? '✅ Logged In' : '✅ Ready';

    // 3. Database Check
    const { error: dbError } = await supabase.from('profiles').select('id').limit(1);
    results.database = dbError ? `❌ ${dbError.message}` : '✅ Tables Found';

    // 4. Storage Check
    const { error: stError } = await supabase.storage.getBucket('memes');
    results.storage = stError ? `❌ ${stError.message}` : '✅ Bucket Found';

  } catch (err: any) {
    results.details = err.message || 'Unknown network error.';
  }

  return results;
};
